import { map, filter, find } from 'lodash-es'
import {
  CUSTOM,
  MENU_TYPE,
  MENU_STRUCTURE,
  MENU,
  MENU_LIST,
  SECTION_LIST,
  DISH_LIST,
  GLOBAL,
  SCRAPING_FLAG,
} from '../../../constants'

const scrapingTagGroupEditorFormInitialValues = data => {
  if (!data) return {}

  const { id, alias, description, tags } = data

  const customTagIds = map(
    filter(tags, ({ type }) => type === CUSTOM),
    'id',
  )

  const menuTypeTagId = find(tags, ({ type }) => type === MENU_TYPE)?.id

  const menuStructureTagId = find(tags, ({ type }) => type === MENU_STRUCTURE)
    ?.id

  const menuTagIds = map(
    filter(tags, ({ type }) => type === MENU),
    'id',
  )

  const menuListTagIds = map(
    filter(tags, ({ type }) => type === MENU_LIST),
    'id',
  )

  const sectionListTagIds = map(
    filter(tags, ({ type }) => type === SECTION_LIST),
    'id',
  )

  const dishListTagIds = map(
    filter(tags, ({ type }) => type === DISH_LIST),
    'id',
  )

  const globalTagIds = map(
    filter(tags, ({ type }) => type === GLOBAL),
    'id',
  )

  const scrapingFlagTagIds = map(
    filter(tags, ({ type }) => type === SCRAPING_FLAG),
    'id',
  )

  return {
    id,
    alias,
    description,
    customTagIds,
    menuTypeTagId,
    menuStructureTagId,
    menuTagIds,
    menuListTagIds,
    sectionListTagIds,
    dishListTagIds,
    globalTagIds,
    scrapingFlagTagIds,
  }
}

export default scrapingTagGroupEditorFormInitialValues
